/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable check-file/filename-naming-convention */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconBookmarkFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconBookmarkFilled"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 3h14v18l-7-4.372L5 21z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconBookmarkFilled;
